function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15_699)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.875 0.5H6.125C3.0184 0.5 0.5 3.0184 0.5 6.125V18.875C0.5 21.9816 3.0184 24.5 6.125 24.5H18.875C21.9816 24.5 24.5 21.9816 24.5 18.875V6.125C24.5 3.0184 21.9816 0.5 18.875 0.5Z",
  fill: "url(#paint0_radial_15_699)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.875 0.5H6.125C3.0184 0.5 0.5 3.0184 0.5 6.125V18.875C0.5 21.9816 3.0184 24.5 6.125 24.5H18.875C21.9816 24.5 24.5 21.9816 24.5 18.875V6.125C24.5 3.0184 21.9816 0.5 18.875 0.5Z",
  fill: "url(#paint1_radial_15_699)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5008 3.125C9.95478 3.125 9.63519 3.13616 8.63525 3.18163C7.63719 3.22738 6.95591 3.38534 6.35984 3.61719C5.74316 3.85662 5.22013 4.17697 4.69906 4.69822C4.17753 5.21937 3.85719 5.74241 3.617 6.35881C3.3845 6.95506 3.22634 7.63662 3.18144 8.63422C3.13672 9.63425 3.125 9.95394 3.125 12.5001C3.125 15.0463 3.13625 15.3648 3.18163 16.3647C3.22756 17.3628 3.38553 18.0441 3.61719 18.6402C3.85681 19.2568 4.17716 19.7799 4.69841 20.3009C5.21938 20.8225 5.74241 21.1436 6.35862 21.383C6.95516 21.6148 7.63653 21.7728 8.63441 21.8186C9.63444 21.864 9.95375 21.8752 12.4997 21.8752C15.0461 21.8752 15.3646 21.864 16.3646 21.8186C17.3626 21.7728 18.0447 21.6148 18.6412 21.383C19.2576 21.1436 19.7799 20.8225 20.3007 20.3009C20.8223 19.7799 21.1425 19.2568 21.3828 18.6404C21.6133 18.0441 21.7715 17.3626 21.8184 16.3649C21.8633 15.365 21.875 15.0463 21.875 12.5001C21.875 9.95394 21.8633 9.63444 21.8184 8.63441C21.7715 7.63634 21.6133 6.95516 21.3828 6.35909C21.1425 5.74241 20.8223 5.21937 20.3007 4.69822C19.7793 4.17678 19.2578 3.85644 18.6406 3.61728C18.043 3.38534 17.3613 3.22728 16.3632 3.18163C15.3632 3.13616 15.0448 3.125 12.4979 3.125H12.5008ZM11.6598 4.81447C11.9095 4.81409 12.188 4.81447 12.5008 4.81447C15.0041 4.81447 15.3007 4.82347 16.2892 4.86838C17.2032 4.91019 17.6994 5.06291 18.0298 5.19125C18.4674 5.36112 18.7793 5.56428 19.1072 5.8925C19.4353 6.22062 19.6384 6.53309 19.8088 6.97062C19.9371 7.30062 20.09 7.79675 20.1316 8.71081C20.1765 9.69913 20.1863 9.99594 20.1863 12.4979C20.1863 14.9999 20.1765 15.2968 20.1316 16.2851C20.0898 17.1991 19.9371 17.6952 19.8088 18.0253C19.6389 18.4629 19.4353 18.7744 19.1072 19.1023C18.7791 19.4305 18.4676 19.6335 18.0298 19.8035C17.6997 19.9324 17.2032 20.0848 16.2892 20.1266C15.3009 20.1715 15.0041 20.1812 12.5008 20.1812C9.99753 20.1812 9.70081 20.1715 8.71259 20.1266C7.79853 20.0844 7.30241 19.9317 6.97166 19.8033C6.53422 19.6333 6.22166 19.4303 5.89353 19.1022C5.56541 18.774 5.36234 18.4623 5.192 18.0246C5.06366 17.6945 4.91075 17.1984 4.86913 16.2843C4.82422 15.296 4.81522 14.9992 4.81522 12.4956C4.81522 9.992 4.82422 9.69678 4.86913 8.70847C4.91094 7.79441 5.06366 7.29828 5.192 6.96781C5.36197 6.53028 5.56541 6.21781 5.89363 5.88969C6.22184 5.56156 6.53422 5.35841 6.97175 5.18816C7.30222 5.05925 7.79853 4.90691 8.71259 4.86491C9.57744 4.82581 9.91259 4.81409 11.6598 4.81212V4.81447ZM17.5052 6.37109C16.8841 6.37109 16.3802 6.87453 16.3802 7.49572C16.3802 8.11681 16.8841 8.62072 17.5052 8.62072C18.1263 8.62072 18.6302 8.11681 18.6302 7.49572C18.6302 6.87463 18.1263 6.37072 17.5052 6.37072V6.37109ZM12.5008 7.68556C9.84209 7.68556 7.68641 9.84125 7.68641 12.5001C7.68641 15.1589 9.84209 17.3136 12.5008 17.3136C15.1597 17.3136 17.3146 15.1589 17.3146 12.5001C17.3146 9.84134 15.1595 7.68556 12.5007 7.68556H12.5008ZM12.5008 9.37503C14.2267 9.37503 15.6259 10.7741 15.6259 12.5001C15.6259 14.2259 14.2267 15.6252 12.5008 15.6252C10.775 15.6252 9.37588 14.2259 9.37588 12.5001C9.37588 10.7741 10.7749 9.37503 12.5008 9.37503Z",
  fill: "white"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_15_699",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.875 26.3485) rotate(-90) scale(23.7858 22.1227)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#FFDD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#FF543E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C837AB"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_15_699",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-3.52009 2.22884) rotate(78.681) scale(10.6324 43.827)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3771C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.128,
  stopColor: "#3771C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6600FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15_699"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0.5 0.5)"
})));

function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f9c8376896b5b54596aae99df008dfda.svg";
export { ForwardRef as ReactComponent };